import { ReactNode } from 'react';

import { ChakraFlex } from '@equip.health/ui';

interface UserContainerProps {
  children: ReactNode;
}

const UserContainer = ({ children }: UserContainerProps) => (
  <ChakraFlex
    alignItems="center"
    height="100%"
    justifyContent="flex-start"
    width="100%"
  >
    {children}
  </ChakraFlex>
);

export default UserContainer;
